import styled from "@emotion/styled";
import { colors, spacing } from "../../constants";

export const FooterContainer = styled.div`
  width: 100%;
  max-width: 100vw;
  height: 100%;
  overflow: hidden;
  background-color: ${colors.neutralLight};
  display: flex;
  padding: ${spacing.paddingLarge};
  align-items: center;
  justify-content: center;
  flex-direction: row;
  border: 1px solid ${colors.neutralDark};
  border-width: 1px 0 0 0;
  transition: background-color 0.25s ease;
`;

export const CopyrightText = styled.div`
  display: flex;
  margin-right: ${spacing.marginMedium};
  width: 50%;
  color: ${colors.neutralDark};
  font-weight: 500;
  font-size: 0.9rem;
`;

export const FooterLinks = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  gap: ${colors.gapMedium};
  width: 50%;
  height: 100%;
  color: ${colors.neutralDark};
  font-size: 1rem;
`;

export const FooterLink = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: ${spacing.gapSmall};
`;

export const FooterAnchor = styled.a`
  text-decoration: none;
  font-weight: 500;
  font-size: clamp(1rem, 2vw, 1rem);
  color: ${colors.neutralDark};
`;
